import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { resetPassword } from '../../features/authSlice'
import { validatePassword } from '../../util/passwordValidation'
import AuthCommonCard from '../../components/molecules/AuthCommonCard'
import AuthCommonForm from '../../components/molecules/AuthCommonForm'

import styles from '../../components/signup/signup.module.scss'
import InputCustom from '../../components/atoms/input/InputCustom'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'

const initialFormData = {
	password: '',
	confirmPassword: '',
}

export const ResetPasswordPage = () => {
	const dispatch = useDispatch()
	const { token } = useParams()
	const [passwordError, setPasswordError] = useState('')
	const [formData, setFormData] = useState(initialFormData)
	const [confirmPasswordError, setConfirmPasswordError] = useState('')
	const handleSubmit = async (e) => {
		e.preventDefault()
		const error = validatePassword(formData.password)
		if (error) return setPasswordError(error)
		if (formData.password !== formData.confirmPassword)
			return setConfirmPasswordError('Passwords do not match')
		dispatch(resetPassword({ token, password: formData.password }))
	}

	return (
		<AuthCommonCard>
			<AuthCommonForm
				title={'Reset Password'}
				subTitle={
					<>Enter and confirm your new password to regain access.</>
				}
			>
				<form
					className={styles.form}
					autoComplete="off"
					onSubmit={handleSubmit}
				>
					<div className={styles.formGroup}>
						<InputCustom
							data-cy="password"
							placeholder="New Password"
							name="password"
							type="password"
							enableShowPassword={true}
							value={formData.password}
							setDataFunction={setFormData}
							data={formData}
							required={true}
							eyeIcon={true}
							error={!!passwordError}
							changeFunction={() => {
								setPasswordError('')
								setConfirmPasswordError('')
							}}
						/>
						{passwordError && (
							<p className="text-error">{passwordError}</p>
						)}
					</div>
					<div className={styles.formGroup}>
						<InputCustom
							data-cy="confirmPassword"
							placeholder="Confirm New Password"
							name="confirmPassword"
							type="password"
							enableShowPassword={true}
							value={formData.confirmPassword}
							setDataFunction={setFormData}
							data={formData}
							required={true}
							eyeIcon={true}
							error={!!confirmPasswordError}
							changeFunction={() => setConfirmPasswordError('')}
						/>
						{confirmPasswordError && (
							<p className="text-error">{confirmPasswordError}</p>
						)}
					</div>
					<div className={styles.signUpBtn}>
						<ButtonCustom variant="default" type="submit">
							Reset Password
						</ButtonCustom>
					</div>
				</form>
			</AuthCommonForm>
		</AuthCommonCard>
	)
}
